import { gql } from "@apollo/client";

export interface ICreateIndustryInput {
  name: string;
  description: string;
}

const CREATE_INDUSTRY = gql`
  mutation CreateIndustry($createIndustryInput: CreateIndustryInput!) {
    createIndustry(createIndustryInput: $createIndustryInput) {
      id
    }
  }
`;

const UPDATE_INDUSTRY = gql`
  mutation UpdateIndustry(
    $updateIndustryId: String!
    $createIndustryInput: CreateIndustryInput!
  ) {
    updateIndustry(
      id: $updateIndustryId
      createIndustryInput: $createIndustryInput
    ) {
      id
    }
  }
`;

const DELETE_INDUSTRY = gql`
  mutation DeleteIndustry($deleteIndustryId: String!) {
    deleteIndustry(id: $deleteIndustryId) {
      id
    }
  }
`;

export default { CREATE_INDUSTRY, UPDATE_INDUSTRY, DELETE_INDUSTRY };
